const mutations = {
	setCursos: (state, cursos) => {
		state.cursos = cursos;
	},


};
export default mutations;
